import { debounce } from "lodash";

const serviceIssueSelector = $(".service-issue-block");
const bannerCloseSelector = $(".service-issue-block .js-banner-close");

const getHeaderHeight = () => {
  if (window.innerWidth <= 960) {
    return $(".header--mobile").height();
  }
  return $(".header--desktop .header__inner").height();
};

const getServiceIssueBlockHeight = () => {
  return $(".header--desktop .service-issue-block").height();
};

const setLayoutResponsiveHeaderHeight = height => {
  if (serviceIssueSelector.length) {
    const layoutResponsiveHeaderSelector = $(".layout-responsive__header");
    layoutResponsiveHeaderSelector.css({ "padding-top": height });
  }
};

const setCookiePolicyPosition = () => {
  const cookiePolicySelector = $(".cookie-policy");
  const formBannerContentSelector = $(".form-banner__content");
  if (serviceIssueSelector.length && cookiePolicySelector.length) {
    cookiePolicySelector.css({ top: getHeaderHeight() + "px" });
  }
  if (serviceIssueSelector.length && formBannerContentSelector.length) {
    const mediaQuery = window.matchMedia("(min-width: 960px)");
    if (mediaQuery.matches) {
      formBannerContentSelector.css({ top: getHeaderHeight() + "px" });
    }
    $(window).on(
      "resize",
      debounce(() => {
        if (mediaQuery.matches) {
          formBannerContentSelector.css({ top: getHeaderHeight() + "px" });
        } else {
          formBannerContentSelector.css({ top: "auto" });
        }
      }, 100)
    );
  }
};

const setCorrectTopPosition = (...args) => {
  const mediaQueryTablet = window.matchMedia(
    "(min-width: 640px) and (max-width: 960px)"
  );
  const mediaQueryLaptop = window.matchMedia(
    "(min-width: 960px) and (max-width: 1280px)"
  );
  const headerDesktopSearchInnerSelector = $(
    ".header--desktop .header-search__inner"
  );

  if (mediaQueryLaptop.matches) {
    headerDesktopSearchInnerSelector.css({
      top: `calc(${getServiceIssueBlockHeight() / 2}px + 50%)`
    });
  } else {
    headerDesktopSearchInnerSelector.css({ top: `50%` });
  }

  args.forEach(element => {
    if (element.hasClass("header-search")) {
      if (mediaQueryTablet.matches) {
        element.css({ top: 0 + "px" });
      } else {
        element.css({ top: getHeaderHeight() + "px" });
      }
    } else {
      element.css({ top: getHeaderHeight() + "px" });
    }
  });
};

const setMobileMenuHeight = () => {
  const mobileMenuSelector = $(".layout-responsive__mobile-menu");
  const categoriesListItemInnerSelector = $(".categories-list__item-inner");
  const headerSearchSelector = $(".header-search");
  const userInfoSelector = $(".header--mobile .user-info");

  if (serviceIssueSelector.length) {
    setCorrectTopPosition(
      mobileMenuSelector,
      categoriesListItemInnerSelector,
      headerSearchSelector,
      userInfoSelector
    );
  }
};

const setHeaderCategoriesWrapperHeight = () => {
  const categoriesListWrapperSelector = $(".categories-list-wrapper");
  const headerNavItemSubmenuSelector = $(".header__nav-item--submenu");
  const headerNavLoginSelector = $(".header__nav-item--login");
  if (serviceIssueSelector.length) {
    categoriesListWrapperSelector.css({ top: getHeaderHeight() + "px" });
    headerNavItemSubmenuSelector.addClass("is-service-issue");
    headerNavLoginSelector.addClass("is-service-issue");
  }
};

const setUsePurposeReminderPosition = () => {
  const usePurposeReminderSelector = $(".use-purpose-reminder");
  if (serviceIssueSelector.length && usePurposeReminderSelector.length) {
    if (window.innerWidth >= 960) {
      usePurposeReminderSelector.css({ top: getHeaderHeight() + 8 + "px" });
    }
    usePurposeReminderSelector.css({ top: "unset" });
  }
};

export const initServiceIssueBlock = () => {
  setLayoutResponsiveHeaderHeight(getHeaderHeight());
  setCookiePolicyPosition();
  setUsePurposeReminderPosition();
  setMobileMenuHeight();
  setHeaderCategoriesWrapperHeight();

  $(window).on(
    "resize",
    debounce(() => {
      setLayoutResponsiveHeaderHeight(getHeaderHeight());
      setCookiePolicyPosition();
      setUsePurposeReminderPosition();
      setMobileMenuHeight();
      setHeaderCategoriesWrapperHeight();
    }, 100)
  );

  bannerCloseSelector.on("click", function() {
    setLayoutResponsiveHeaderHeight(getHeaderHeight());
    setCookiePolicyPosition();
    setUsePurposeReminderPosition();
    setMobileMenuHeight();
    setHeaderCategoriesWrapperHeight();
    $(".header__nav-item").removeClass("is-service-issue");
    document.cookie =
      "service-issue-support=true; expires=Fri, 31 Dec 2100 23:59:59 GMT; path=/";
  });
};
